import { render, staticRenderFns } from "./batchNumberDetail.vue?vue&type=template&id=d842d230&scoped=true"
import script from "./batchNumberDetail.vue?vue&type=script&lang=js"
export * from "./batchNumberDetail.vue?vue&type=script&lang=js"
import style0 from "./batchNumberDetail.vue?vue&type=style&index=0&id=d842d230&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d842d230",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d842d230')) {
      api.createRecord('d842d230', component.options)
    } else {
      api.reload('d842d230', component.options)
    }
    module.hot.accept("./batchNumberDetail.vue?vue&type=template&id=d842d230&scoped=true", function () {
      api.rerender('d842d230', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/receivableManagementSite/toExamine/cmp/batchNumberDetail.vue"
export default component.exports